import React, { useEffect } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { closePortal } from 'reducers/portal';
// hooks
import usePortalState from 'utils/hooks/usePortalState';
// other
import cn from 'classnames';
import './RootPortal.scss';

const RootPortal = ({
  component,
  closePortal,
  options,
  pathname,
}) => {
  const [{ isVisible, content }] = usePortalState(component);
  const { hasFooterArea } = options;

  useEffect(() => {
    if (component) closePortal();
  }, [pathname]);

  return (
    <div className={cn('RootNodePortal', { isOpen: isVisible, 'has-footer-area': hasFooterArea })}>
      {content
        ? React.cloneElement(content, { closePortal })
        : null}
    </div>
  );
};

RootPortal.propTypes = {
  closePortal: T.func.isRequired,
  options: T.object.isRequired,
  component: T.element,
  pathname: T.string,
};

export default connect(
  (state) => ({
    options: state.portal.options,
    component: state.portal.component,
  }),
  { closePortal }
)(RootPortal);
